import MAIN_COMPONENT from './main';
import TITLE_CONTAINER from './title-container';
import COMPATS_TITLE from './compats-title';
import HIGHLIGHTS from '../../common/components/highlights';
import COMPATSS from '../../common/components/compats';
import { constants } from '../../../../../../utils/octopus';

const { OWNERSHIPS } = constants;

const compats = {
  resolver: props => {
    const { highlights, title_compats } = props;
    return highlights || title_compats;
  },
  definitions: {
    ...MAIN_COMPONENT,
    ...TITLE_CONTAINER,
    ...COMPATS_TITLE,
    ...HIGHLIGHTS,
    ...COMPATSS,
  },
  ownership: OWNERSHIPS.COMPATS,
  deps: ['highlights', 'title_compats'],
};

export default compats;
